module.exports = __webpack_public_path__ + "img/羽毛球.cd5a607b.png";